<template>
  <div>
    <card header-classes="bg-transparent">
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h3>{{ variables.get('followerTimeGraph') }}</h3>
        </div>
        <div class="col text-right">
          <el-radio-group v-model="chart_type" @change="changeGraph" size="mini">
            <el-radio-button label="1">Takipçi - Zaman</el-radio-button>
            <el-radio-button label="2">Takipçi Artış</el-radio-button>
          </el-radio-group>
          <el-select
            class="form-control-alternative"
            prop="type"
            v-model="followerCountByTimeFilter.report_type"
          >
            <el-option
              v-for="type in report_types"
              :key="type.value"
              :label="type.label"
              :value="type.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <template v-loading="loading">
        <div v-if="chart_type == 1">
          <follower-count-by-time :report_type="followerCountByTimeFilter.report_type"></follower-count-by-time>
        </div>
        <div v-else>
          <follower-increase-by-time :report_type="followerCountByTimeFilter.report_type"></follower-increase-by-time>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import { variables } from "@/langs/tr";
import * as axios from "axios";
import { Bar, Line } from "vue-chartjs";
import Vue from "vue";

Vue.component("follower-count-by-time", {
  extends: Bar,
  props: {
    report_type: null,
  },
  watch: {
    report_type: function () {
      this.getFollowerStats();
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.getFollowerStats();
  },
  methods: {
    getFollowerStats() {
      axios
        .get("company/follower-stats?report_type=" + this.report_type)
        .then((response) => {
          this.renderChart(response.data, {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  stacked: true,
                  ticks: {
                    beginAtZero: true,
                    callback: function (value) {
                      if (value % 1 === 0) {
                        return value;
                      }
                    },
                    min: 0,
                  },
                },
              ],
              xAxes: [
                {
                  stacked: true,
                  ticks: {
                    beginAtZero: true,
                    categoryPercentage: 1,
                    barPercentage: 1,
                  },
                },
              ],
            },
          });
          this.loading = false;
        });
    },
  },
});
Vue.component("follower-increase-by-time", {
  extends: Line,
  props: {
    report_type: null,
  },

  watch: {
    report_type: function () {
      this.getFollowerIncreaseStats();
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.getFollowerIncreaseStats();
  },
  methods: {
    getFollowerIncreaseStats() {
      axios
        .get("company/follower-increase-stats?report_type=" + this.report_type)
        .then((response) => {
          this.renderChart(response.data, {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  stacked: true,
                  ticks: {
                    beginAtZero: true,
                    callback: function (value) {
                      if (value % 1 === 0) {
                        return value;
                      }
                    },
                    min: 0,
                  },
                },
              ],
              xAxes: [
                {
                  stacked: true,
                  ticks: {
                    beginAtZero: true,
                    categoryPercentage: 1,
                    barPercentage: 1,
                  },
                },
              ],
            },
          });
          this.loading = false;
        });
    },
  },
});

export default {
  name: "follower-charts",
  data() {
    return {
      variables,
      statistics: null,
      follower_increase_stats: null,
      last_applications: null,
      chart_type: 1,
      chart_title: null,
      start_date: null,
      loading: true,
      followerCountByTimeFilter: {
        report_type: "last_week",
      },
      report_types: [
        {
          value: "last_week",
          label: "Son Hafta",
        },
        {
          value: "last_month",
          label: "Son Ay",
        },
        {
          value: "last_3_months",
          label: "Son 3 Ay",
        },
        {
          value: "last_6_months",
          label: "Son 6 Ay",
        },
        {
          value: "last_year",
          label: "Son Yıl",
        },
      ],
    };
  },
  created() {
    this.changeGraph(1);
  },
  methods: {
    changeGraph(chart_type) {
      if (chart_type == 1) {
        this.chart_title = "Takipçi - Zaman Grafiği";
      } else {
        this.chart_title = "Takipçi Artış Grafiği";
      }
    },
  },
  filters: {
    fixDate: function (date) {
      if (!date) {
        return "";
      }
      let items = date.split(" ")[0].split("-");
      return items[2] + "." + items[1] + "." + items[0];
    },
  },
};
</script>
<style>
</style>
